export default __webpack_public_path__ + "static/media/1-new1.df011076.png";